<template>
  <!-- <s-sub-header :pageName="pageName"> -->
    <!-- <template #categories class="teste"> -->
      <div>
        <ul class="category-buttons mostly-customized-scrollbar">
          <SButtonMaterial
            buttonType="button"
            color="white"
            textColor="primary"
            borderColor="primary"
            materialClass="dense"
            :text="buttonText"
            iconLeftText="share"
            iconColor="primary"
            @button="openShareModal"
            data-cy="shareProfileButton"
            class="share-button"
            v-if="isUserLogged"
          />
          <li v-for="category in categories" :key="category.name">
            <div></div> <!-- this div align when inline-block -->
            <md-button v-if="category.name == 'Free'" @click="selectCategory(category)" class="md-sm small-screen-size"
              :class="{ 'highlight-button': selectedCategory === category.name }"
            >
              <div class="categories-content">
                <img v-if="selectedCategory === category.name" src="/img/free-tag-label-blue.png" alt="" class="free-tag-size"/>
                <img v-else src="/img/free-tag-label.png" alt="" class="free-tag-size"/>
              </div>
            </md-button>
            <md-button v-else @click="selectCategory(category)" class="md-sm small-screen-size"
              :class="{ 'highlight-button': selectedCategory === category.name }"
            >
              <div class="categories-content">
                <em :class="[category.iconClass]" class="fitting-adjustments">{{
                  category.icon
                }}</em>
                <span>{{ category.name }}</span>
              </div>
            </md-button>
          </li>
        </ul>
        <Modal
          id="share-inventory-modal"
          title="Share your inventory"
          ref="modal"
        >
          <h5 class="login-text">Copy and share this link with your friends</h5>
          <ShareInventory :category="this.selectedCategory" @closeModal="closeShareModal" :userInfo="userInfo"></ShareInventory>
        </Modal>
      </div>

    <!-- </template> -->
  <!-- </s-sub-header> -->
</template>

<script>
// import SSubHeader from "@/material-components/organisms/ProfileSubHeader.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import Modal from "@/components/atoms/Modal.vue";
import ShareInventory from "@/material-components/molecules/ShareInventory.vue";
import { mapGetters } from "vuex";
export default {
  name: "ProfileCategories",
  props: ["categories", "pageName", "userInfo"],
  components: {
    // SSubHeader,
    ShareInventory,
    Modal,
    SButtonMaterial
  },
  data() {
    return {
      buttonText: "Share these items",
      selectedCategory: null,
    };
  },
  computed: {
    ...mapGetters({
      isUserAuthenticated: "isUserAuthenticated",
    }),
    isUserLogged(){
      // const route_name = this.$route.name
      // const route_params = this.$route.params

      // if (route_name === 'InventoryProfileItems') return true

      // if (route_name === 'InventoryItems' || route_name === 'InventoryItemsCategory') {
      //   const logged = JSON.parse(localStorage.getItem('loggedUser'))

      //   if (logged === null) return false

      //   if(route_params.username !== logged.username) return false

      //   return true
      // }

      return true
    }
  },
  methods: {
    selectCategory(category) {
      if (this.selectedCategory === category.name){
        this.selectedCategory = null;
        this.$emit("categoryButton", null)
    } else {
        this.selectedCategory = category.name;
        this.$emit("categoryButton", category)
      }
    },
    openShareModal() {
      $("#share-inventory-modal").modal("show");
    },
    closeShareModal() {
      $("#share-inventory-modal").modal("hide")
    }
  },
  created() {
    const route_params = this.$route.params

    if(route_params.category) {
      this.selectedCategory = route_params.category
    }
  },
};
</script>

<style lang="scss" scoped>
.list-category ul {
  list-style: none !important;
  list-style-type: none;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
}
.highlight-button {
  border: solid;
  border-color: $primary;
  background-color: white !important;
  color: $primary !important;
}
.share-button {
  display: flex;
  height: 50px;
  margin: 6px;
  min-width: 150px;
}
.category-buttons {
  display: flex;
  overflow: scroll;
}
.md-subheader {
  top: 0 !important;
  position: unset !important;
}
.list-category ul li {
  display: inline-flex;
  max-width: 95px;
}
.categories-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.teste {
  display: flex;
}
.small-screen-size {
  max-width: 70px;
  min-width: 70px;
  max-height: 50px;
  min-height: 50px;
}
.fitting-adjustments {
  margin-bottom: 5px;
}
@media screen and (max-width: 1192px) {
  .small-screen-size {
    max-width: 58px;
    min-width: 58px;
  }
}
.md-sm {
  font-family: inherit;
  background-color: #05919B;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  flex-basis: 70%;
  flex-shrink: 1;
  color: #fff;
}

.md-sm span {
  font-size: xx-small;
}

.icon {
  display: flex-start;
  font-size: larger;
}

.container {
  margin-top: 150px;
}

.electronic-class {
  margin-right: -1px !important;
}

.clothing-class {
  margin-right: 2px !important;
}

.household-class {
  margin-right: 3px !important;
}
.free-tag-size {
  width: 75%;
}

@media screen and (min-width: 1024px) and (max-width: 1300px) {
  .list-category ul {
    justify-content: center;
  }
}
@media screen and (max-width: 1024px) {
  .list-category ul {
    display: inline-block !important;
  }
}
::-webkit-scrollbar {
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #e1e1e1;
}
::-webkit-scrollbar-track-piece {
  background: #e1e1e1;
}
::-webkit-scrollbar-thumb {
  background: #757575;
}
::-webkit-scrollbar:horizontal{
  display: show;
}
::-webkit-scrollbar:vertical{
  display: none;
}
</style>
